/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MostWatchedByThemeRequest { 
    grade?: string | null;
    level?: string | null;
    theme?: string | null;
    tag?: string | null;
    publisher?: string | null;
    hasQuiz?: boolean | null;
    quizId?: string | null;
    datePublishedFromUtc?: string | null;
    datePublishedToUtc?: string | null;
    metric?: string | null;
    topThemes?: number;
    maxVideosPerTheme?: number;
}

